import Stack from "@mui/material/Stack";
import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import { COLOR_BLACK } from "shared/theme/colors";
import { useTagDetails } from "../../../../context";
import { TagTypeField } from "../../../TagTypeField";

const General: FC = () => {
  const {
    tagName,
    submitting,
    tagDescription,
    onChangeTagName,
    tagType,
    setTagType,
    tagTypeInput,
    servicePrimaryTags,
    onSubmitTagType,
    isTagTypesLoading,
  } = useTagDetails();

  return (
    <ContentSection title="GENERAL">
      <Stack spacing="1rem">
        <TagTypeField
          id="tag-type-autocomplete"
          value={tagType}
          inputProps={tagTypeInput}
          options={
            servicePrimaryTags?.map((tag) => ({
              id: tag.id,
              name: tag.name,
            })) || []
          }
          onChange={(_, value) => {
            setTagType(value);
            tagName?.setErrors([]);
          }}
          placeholder="Type"
          onSubmitTagType={() => !submitting && onSubmitTagType()}
          loading={isTagTypesLoading}
        />
        <TextField
          id="tagName"
          label="Secondary Tag *"
          placeholder="Name"
          fullWidth
          required
          value={tagName?.input.value}
          onChange={onChangeTagName}
          errors={tagName?.input.errors}
          labelColor={COLOR_BLACK}
        />
        <TextField
          id="tagDescription"
          label="Description"
          fullWidth
          placeholder="Description (optional)"
          required
          value={tagDescription?.input.value}
          onChange={(e) => tagDescription?.setValue(e.target.value)}
          labelColor={COLOR_BLACK}
        />
      </Stack>
    </ContentSection>
  );
};

export default General;
